import { formatMonthDay } from '@/shared/lib/time-utils';

export function formatFirstScheduledSession(date: string | Date): string {
    const parsed = new Date(date);
    const onTheHour = parsed.getMinutes() === 0;

    const time = parsed
        .toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: onTheHour ? undefined : '2-digit',
            hour12: true,
        })
        .toLowerCase();

    return `${formatMonthDay(parsed)}, ${time}`;
}
